import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'environments/environment';
import { Observable, of } from 'rxjs';
import { LayoutPoliza } from '../models/layout-poliza';
import { agGridLayoutPolizasDefs } from '../models/layout-poliza-def';
const BACKEND_URL = environment.apiUrl + '/temporalpolizas';


@Injectable({
  providedIn: 'root'
})
export class InterfacePolizasService {
  definicionColumnas = agGridLayoutPolizasDefs;

  constructor(private fb: FormBuilder, private http: HttpClient) { }

  public obtenerListadoValidacionesPolizas(): Observable<LayoutPoliza[]> {
    const polizas: LayoutPoliza[] = [];
    // const poliza ={
    //   cl_amater: 'TEST',
    //   cl_apater: 'TEST',
    //   cl_aseg: 'TEST',
    //   cl_celu: 'TEST',
    //   cl_codclt: 'TEST',
    //   cl_col: 'TEST',
    //   cl_cont1: 'TEST',
    //   cl_cont2: 'TEST',
    //   cl_coor: 'TEST',
    //   cl_dom: 'TEST',
    //   cl_email: 'TEST',
    //   cl_email2: 'TEST',
    //   cl_fela: new Date(),
    //   cl_gpo: 'TEST',
    //   cl_nombre: 'TEST',
    //   cl_num: 1,
    //   cl_pob: 'TEST',
    //   cl_rfc: 'TEST',
    //   cl_telc: 'TEST',
    //   cl_telo: 'TEST',
    //   cl_telo2: 'TEST',
    // };
    // polizas.push(poliza);
    return of(polizas);
  }

  public obtenerListadoValidacionesPolizasArray(): any {

    const polizas: LayoutPoliza[] = [];

    for (let index = 0; index < 10; index++) {

      // const poliza = {
      //   cl_amater: 'TEST',
      //   cl_apater: 'TEST',
      //   cl_aseg: 'TEST',
      //   cl_celu: 'TEST',
      //   cl_codclt: 'TEST',
      //   cl_col: 'TEST',
      //   cl_cont1: 'TEST',
      //   cl_cont2: 'TEST',
      //   cl_coor: 'TEST',
      //   cl_dom: 'TEST',
      //   cl_email: 'TEST',
      //   cl_email2: 'TEST',
      //   cl_fela: new Date(),
      //   cl_gpo: 'TEST',
      //   cl_nombre: 'TEST',
      //   cl_num: 1,
      //   cl_pob: 'TEST',
      //   cl_rfc: 'TEST',
      //   cl_telc: 'TEST',
      //   cl_telo: 'TEST',
      //   cl_telo2: 'TEST',
      // };
      // polizas.push(poliza);

    }

    return polizas;
  }


  public obtenerFormularioInterfacePolizas(): FormGroup {
    return this.fb.group({
      nombre_ruta: new FormControl(null, Validators.required),
      archivo: new FormControl(null, Validators.required),
      soloLeerVerificarFormato: new FormControl(false),
      validarValoresCatalogo: new FormControl(false),
      reprocesarInformacion: new FormControl(false),
      remplazarPolizasExistentes: new FormControl(false),
      incisosFlotillasComoPolizas: new FormControl(false),
      generarEndososCancelacion: new FormControl(false),
      diasInfHist: new FormControl()
    });
  }

  public obtenerFormularioAplicarValores(): FormGroup {
    return this.fb.group({
      columna: new FormControl(null, { validators: [Validators.required] }),
      valor: new FormControl(null, { validators: [Validators.required] }),
      soloCamposEnBlanco: new FormControl(false),
      campoReemplazo: new FormControl('')
    });
  }

  /**
   * Obtiene el listado de columnas para el control select.
   */
  obtenerColumnasGrid(): any[] {
    const columnas = [];
    for (const propiedad of this.definicionColumnas) {
      if (propiedad.field !== 'id' && propiedad.field !== 'error' && propiedad.field !== 'usuario' && propiedad.field !== 'archivo') {
        columnas.push({ id: propiedad.field, descripcion: propiedad.headerName });
      }
    }
    return columnas;
  }

  /**
   * Obtiene la configuración default de grid.
   */
  obtenerConfiguracionDefaultCols(): any {
    return {
      sortable: true,
      resizable: true,
      filter: true,
      editable: true
    };
  }

  /**
   * Carga la información de la poliza a procesar al backend.
   * @param layout que se enviara al backend.
   */
  cargarLayout(layout: any): Observable<any> {

    // Obtenemos archivo del formulario.
    const archivo = (layout.archivo as HTMLInputElement).files[0];
    const fechaCreacion = archivo.lastModified + '';
    // Creamos el body del request y cargamos propiedades del layout.
    const postData = new FormData();
    postData.append('fecha_archivo', fechaCreacion);
    postData.append('nombre_ruta', layout.nombre_ruta);
    postData.append('remplazarPolizasExistentes', layout.remplazarPolizasExistentes);
    postData.append('incisosFlotillasComoPolizas', layout.incisosFlotillasComoPolizas);
    postData.append('reprocesarInformacion', layout.reprocesarInformacion);
    postData.append('generarEndososCancelacion', layout.generarEndososCancelacion);
    postData.append('soloLeerVerificarFormato', layout.soloLeerVerificarFormato);
    postData.append('validarValoresCatalogo', layout.validarValoresCatalogo);
    postData.append('layoutPolizas', archivo, archivo.name);

    return this.http.post(BACKEND_URL, postData);
  }

  aplicarModoEdicion(polizas: LayoutPoliza[]): Observable<any>{
    return this.http.post(BACKEND_URL + '/aplicarmodoedicion', polizas);
  }

  obtenerComboArchivo(): Observable<any> {
    return this.http.get(BACKEND_URL + '/comboarchivo');
  }

  obtenerRegistrosArchvio(nombreArchivo): Observable<any> {
    const params = new HttpParams().set('nombreArchivo', nombreArchivo);
    return this.http.get(BACKEND_URL + '/obtenerarchivo', { params: params });
  }

  procesarOCorregirPolizas(polizas, layout: any): Observable<any>{
    polizas.push({
                 'remplazarPolizasExistentes': layout.remplazarPolizasExistentes,
                 'incisosFlotillasComoPolizas': layout.incisosFlotillasComoPolizas,
                 'reprocesarInformacion': layout.reprocesarInformacion,
                 'generarEndososCancelacion': layout.generarEndososCancelacion,
                 'soloLeerVerificarFormato': layout.soloLeerVerificarFormato,
                 'validarValoresCatalogo': layout.validarValoresCatalogo});
    return this.http.post(BACKEND_URL + '/procesar', polizas);
  }

  procesarTodo(polizas, layout: any): Observable<any>{

    polizas.push({
                 'remplazarPolizasExistentes': layout.remplazarPolizasExistentes,
                 'incisosFlotillasComoPolizas': layout.incisosFlotillasComoPolizas,
                 'reprocesarInformacion': layout.reprocesarInformacion,
                 'generarEndososCancelacion': layout.generarEndososCancelacion,
                 'soloLeerVerificarFormato': layout.soloLeerVerificarFormato,
                 'validarValoresCatalogo': layout.validarValoresCatalogo});
    return this.http.post(BACKEND_URL + '/procesartodo', polizas );
  }

  cambiarEditado(archivo: any): Observable<any> {
    return this.http.get(BACKEND_URL + '/cambiareditado', { params: new HttpParams().append('archivo', archivo) });
  }
}
